import { Linking, NativeModules, Platform } from 'react-native';
import { storeReviewUrlFor } from './appUpdateConfig';

// Store reviews, the official way only:
// - requestNativeStoreReview(): StoreKit / Play In-App Review. Used ONLY by
//   the optional-nudge host at a calm moment after neutral engagement
//   criteria (optionalNudges.ts reviewRequestDecision) — never from a button
//   and never based on the private survey rating. The OS decides whether a
//   dialog appears; `true` means "requested", not "reviewed".
// - openStoreReviewPage(): the persistent "Rate Tonyte" Settings row and the
//   review reminder push. Opens the store listing (iOS: write-review page),
//   which both Apple and Google recommend for user-initiated actions.

export async function requestNativeStoreReview(): Promise<boolean> {
  try {
    if (Platform.OS === 'ios') return Boolean(await NativeModules.TonyteAppInfo?.requestStoreReview?.());
    if (Platform.OS === 'android') return Boolean(await NativeModules.TonyteStoreReview?.requestReview?.());
  } catch {
    // Errors must not change the app's normal flow (Play guidance).
  }
  return false;
}

export function canOpenStoreReviewPage(): boolean {
  return Platform.OS === 'ios' || Platform.OS === 'android';
}

export async function openStoreReviewPage(): Promise<boolean> {
  const url = storeReviewUrlFor(Platform.OS);
  if (!url) return false;
  try {
    await Linking.openURL(url);
    return true;
  } catch {
    return false;
  }
}
